<template>
  <div class="container">
    <com-title title="极客邦科技旗下产品及业务"></com-title>
    <ul class="content columns is-mobile">
      <li v-for="(item, index) in data" :key="index" class="column is-half-mobile">
        <a class="wrap" :href="item.link" target="_blank">
          <div class="img">
            <img :src="item.img" alt="">
          </div>
          <span>{{item.word}}</span>
        </a>
        <span class="line"></span>
      </li>
    </ul>
  </div>
</template>
<script>
import comTitle from '@/base/title'
export default {
  data () {
    return {}
  },
  props: ['data'],
  components: {
    comTitle
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

.content
  margin-bottom: 50px
  flex-wrap: wrap
  .column
    display: flex
    justify-content: center
    align-items: center
    position: relative
    &:last-child
      .line
        display: none
    +mobile
      &:nth-child(2n)
        .line
          display: none
    .wrap
      display: flex
      flex-direction: column
      align-items: center
      transition: all linear 0.3s
      &:hover
        transform: translateY(-8px)
      span
        font-size: 14px
      .img
        img
          width: 60px
          margin-bottom: 8px
          +mobile
            width: 50px
            margin-bottom: 4px
    .line
      position: absolute
      right: 0
      width: 1px
      height: 70%
      background-color: #ddd
      +mobile
        height: 50%
</style>
